import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getAllOriginals } from 'utils/legacyEbService';

const useMedia = () => {
  const { status, data: all } = useQuery('originals', getAllOriginals);

  const originalIds = (all || []).map(a => a.id);

  const media = useMemo(() => {
    if (!all) return {};

    return all.reduce((a, og) => {
      const res = {
        ...a,
        [og.id]: og.media,
      };
      if (og.print) {
        res[og.print.id] = og.media;
      }
      return res;
    }, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalIds.length]);

  return {
    media,
    status,
  };
};

export default useMedia;
